export const PRIVATE_ADMIN_LIST_JOBPOSITIONS = '/private/admin/job-positions';
